'use strict';

import { applyFirstSpiritLazySizesConfig } from './firstspirit-lazyload-config';

applyFirstSpiritLazySizesConfig();
require('lazysizes');
